// tab对应的状态
export const tabIndex = [
  {
    id: 0,
    label: "全部",
    name: "first",
  },
  {
    id: 1,
    label: "待审核",
    name: "second",
  },
  {
    id: 2,
    label: "已通过",
    name: "third",
  },
  {
    id: 3,
    label: "已驳回",
    name: "fourth",
  },
];

// 向后台传参时用
export function getTabIndexParam(name) {
  let target = tabIndex.find((tab) => tab.name == name);
  return target ? target.id : null;
}

// 在dialog里切换选择什么目标
export const selectTabs = {
  Depart: 'depart',
  Group: 'group'
}
